import axios from "../service/axios/axios";

export default {
  // 获取积分赠送类型 1.积分变动，2积分跟踪
  getIntegralType(data) {
    return axios({
      method: "post",
      url: "platform/Integral/getIntegralType",
      data,
    });
  },
  /********* 赠送积分 ************/
  // 获取赠送积分记录
  getIntegralGiveLog(data) {
    return axios({
      method: "post",
      url: "platform/shop/getIntegralGiveLog",
      data,
    });
  },
  // 获取赠送积分类型
  getIntegralGiveType(data) {
    return axios({
      method: "post",
      url: "platform/shop/getIntegralGiveType",
      data,
    });
  },
  // 赠送积分
  userIntegralGive(data) {
    return axios({
      method: "post",
      url: "platform/shop/userIntegralGive",
      data,
    });
  },
  /* **** 积分兑换---start **** */
  // 积分兑换列表
  getExchangeCouponList(data) {
    return axios({
      method: "post",
      url: "platform/Healthcard/getExchangeCouponList",
      data: data,
    });
  },
  // 添加兑换
  addExchangeCoupon(data) {
    return axios({
      method: "post",
      url: "platform/Healthcard/addExchangeCoupon",
      data: data,
    });
  },
  // 删除积分兑换
  deleteExchangeCoupon(data) {
    return axios({
      method: "post",
      url: "platform/Healthcard/deleteExchangeCoupon",
      data: data,
    });
  },
  // 积分兑换排序
  sortExchangeCoupon(data) {
    return axios({
      method: "post",
      url: "platform/Healthcard/sortExchangeCoupon",
      data: data,
    });
  },
  /* **** 积分兑换---end **** */
  /* **** 用户芸豆记录---start **** */
  // 获取用户芸豆记录
  getUserBeanList(data) {
    return axios({
      method: "post",
      url: "platform/Integral/getUserBeanList",
      data: data,
    });
  },
  // 获取芸豆变动表记录
  getUserBeanLogList(data) {
    return axios({
      method: "post",
      url: "platform/Integral/getUserBeanLogList",
      data: data,
    });
  },
  // 获取芸豆设置信息
  getBeanConfigInfo(data) {
    return axios({
      method: "post",
      url: "platform/Integral/getBeanConfigInfo",
      data: data,
    });
  },
  // 修改芸豆设置信息
  updateBeanConfigInfo(data) {
    return axios({
      method: "post",
      url: "platform/Integral/updateBeanConfigInfo",
      data: data,
    });
  },
  /* **** 用户芸豆记录---end **** */
  /* **** 积分发放情况---start **** */
  // 积分发放列表
  getIntegralIssueList(data) {
    return axios({
      method: "post",
      url: "platform/Integral/getIntegralIssueList",
      data: data,
    });
  },
  // 导出积分发放列表
  exportIntegralIssueList(data) {
    return axios({
      method: "post",
      url: "platform/Integral/exportIntegralIssueList",
      data: data,
    });
  },
  // 积分使用列表
  getIntegralUseList(data) {
    return axios({
      method: "post",
      url: "platform/Integral/getIntegralUseList",
      data: data,
    });
  },
  // 导出积分使用列表
  exportIntegralUseList(data) {
    return axios({
      method: "post",
      url: "platform/Integral/exportIntegralUseList",
      data: data,
    });
  },
  /* **** 积分发放情况---end **** */
};
